import { Button, Group, iconSizes, Stack, Text } from '@common/ui'
import { IconCirclePlus } from '@common/ui/icons'
import { com } from '@eidu/web'
import { PermissionWithId } from '../input/PermissionsInput'
import PermissionEditorRow from './PermissionEditorRow'
import { ColDef, EntityRow } from './utils'
import EntityType = com.eidu.entity.type.EntityType
import EntityTypeId = com.eidu.entity.type.EntityTypeId
import Permission = com.eidu.entity.permission.Permission

type CellEditorProps = {
  row: EntityRow
  col: ColDef
  permissions: readonly PermissionWithId[]
  entityTypes: readonly EntityType[]
  allowsPath: boolean
  userEntityTypeId: EntityTypeId | undefined
  onAdd: () => void
  onReplace: (id: string, permission: Permission) => void
  onDelete: (id: string) => void
}

const CellEditor = ({
  row,
  col,
  permissions,
  entityTypes,
  allowsPath,
  userEntityTypeId,
  onAdd,
  onReplace,
  onDelete,
}: CellEditorProps) => (
  <Stack gap="xs">
    <Group gap="xs" align="center" wrap="nowrap">
      <col.Icon size={iconSizes.xs} stroke={1.5} />
      <Text size="sm" fw={600}>
        {col.label} — {row.label}
      </Text>
    </Group>
    <Stack gap="xs">
      {permissions.map((p) => (
        <PermissionEditorRow
          key={p.id}
          permission={p.permission}
          allowsPath={allowsPath}
          userEntityTypeId={userEntityTypeId}
          entityTypes={entityTypes}
          rowEntityTypeId={row.entityTypeId}
          action={col.action}
          onChange={(newPerm) => onReplace(p.id, newPerm)}
          onDelete={() => onDelete(p.id)}
        />
      ))}
    </Stack>
    <div>
      <Button
        size="xs"
        variant="subtle"
        leftSection={<IconCirclePlus size={iconSizes.xs} stroke={1.5} />}
        onClick={onAdd}
      >
        Add another
      </Button>
    </div>
  </Stack>
)

export default CellEditor
